// Fallback products are missing from the country catalog: Commerce Layer may
// still have stock, but they must not be sold online
export const getOnlineAvailability = (
  inStock: boolean,
  isFallback?: boolean
) => ({
  isAvailable: inStock && !isFallback,
  notAvailableOnline: !!isFallback,
})
